import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ErrorModal.module.css";

export default function ErrorModal() {
    const dispatch = useDispatch();
    const errorMessage = useSelector((state) => state.ui.errorModalMessage);

    const handleClose = () => {

        dispatch(uiActions.setPopUpModalActive(false))
        dispatch(uiActions.setErrorModalActive(false));
        dispatch(uiActions.setErrorModalMessage(""));
    };

    return (
        <PopUpModal handleClose={handleClose}>
            <div className={styles.contentMain}>
                <h2>Error</h2>
                <p>{errorMessage || "An error occurred."}</p>
                <button onClick={handleClose} className={styles.closeButton}>OK</button>
            </div>
        </PopUpModal>
    );
}
